export default __webpack_public_path__ + "static/style-tip-colors-patterns-89557a7e95d1b990bcd66562b65a57b6.png";